export const LOAD_PLANNING = 'LOAD_PLANNING';
export const SET_PLANNING_FILTER = 'SET_PLANNING_FILTER';
export const RESET_PLANNING_FILTERS = 'RESET_PLANNING_FILTERS';
export const PREPARE_FORM_VERSION = 'PREPARE_FORM_VERSION';
export const SIMULATE_FORM_VERSION_PLANNING = 'SIMULATE_FORM_VERSION_PLANNING';
export const REMOVE_NEW_EVENTS = 'REMOVE_NEW_EVENTS';
export const PLAN_FORM_VERSION = 'PLAN_FORM_VERSION';
export const EDIT_FORM_VERSION = 'EDIT_FORM_VERSION';
export const ADD_RESERVATION = 'ADD_RESERVATION';
export const DELETE_RESERVATION = 'DELETE_RESERVATION';
export const PREPARE_BULK_FORMS = 'PREPARE_BULK_FORMS';
export const VERIFY_MULTIPLE_FORM_VERSIONS = 'VERIFY_MULTIPLE_FORM_VERSIONS';
export const PLAN_BLUK_FORM_VERSIONS = 'PLAN_BLUK_FORM_VERSIONS';
export const DISPLAY_REDIRECTION_BUTTON = 'DISPLAY_REDIRECTION_BUTTON';
export const SET_CALCULATION_STATUS = 'SET_CALCULATION_STATUS';
export const SET_EXTRA_PARAMS = 'SET_EXTRA_PARAMS';
export const TOGGLE_REPLAN_GROUPED_FVS = 'TOGGLE_REPLAN_GROUPED_FVS';
export const TOGGLE_EDIT_RESERVATION = 'TOGGLE_EDIT_RESERVATION';
export const EDIT_RESERVATION = 'EDIT_RESERVATION';
